import React from 'react'
import PropTypes from 'prop-types'
import * as _ from 'lodash'

import { AppLayoutMenuItems } from './AppLayoutMenuItems'

/**
 * AppLayoutMenubar component renders a sidebar menu with navigation links
 * filtered and grouped based on user roles and permissions.
 *
 * @module appLayout/AppLayoutMenubar
 * @description AppLayoutMenubar component renders a sidebar menu with navigation links
 * filtered and grouped based on user roles and permissions.
 * @example
 * const envData = { REACT_APP_THEME_LOGO: '/path/to/logo.png' };
 * const toggleMenu = true;
 * const setToggleMenu = () => {};
 * const sideMenuRef = React.createRef();
 * const authDetails = {
 *   session: { pages: [{ pageRoles: [{ roleName: 'admin' }] }] },
 *   role: 'admin',
 * };
 * const routesData = [
 *   {
 *     isPrivate: 1,
 *     pageName: 'Dashboard',
 *     apiEndPointSchema: { group: 'Main', noMenu: false },
 *     pageTitle: 'Dashboard',
 *   },
 *   // More route objects...
 * ];
 *
 * return (
 *   <AppLayoutMenubar
 *     toggleMenu={toggleMenu}
 *     setToggleMenu={setToggleMenu}
 *     sideMenuRef={sideMenuRef}
 *     envData={envData}
 *     authDetails={authDetails}
 *     routesData={routesData}
 *   />
 * );
 *
 * @param {Object} envData - Environment-specific data
 * @param {string} envData.REACT_APP_THEME_LOGO - URL of the logo to display
 * @param {boolean} toggleMenu - Boolean that determines if the menu is toggled
 * @param {function} setToggleMenu - Function to toggle the menu visibility
 * @param {Object} sideMenuRef - React ref object for the sidebar element
 * @param {Object} authDetails - Authentication details of the current user
 * @param {Object} authDetails.session - Current session details
 * @param {Array} authDetails.session.pages - Array of page objects accessible to the user
 * @param {string} authDetails.role - Role of the current user
 * @param {Array} routesData - Array of route objects
 * @param {number} routesData[].isPrivate - Indicates if the route is private (1) or public (0)
 * @param {string} routesData[].pageName - Name of the page
 * @param {string} routesData[].pageTitle - Title of the page
 * @param {Object} routesData[].apiEndPointSchema - Schema containing endpoint details
 * @param {string} routesData[].apiEndPointSchema.group - Group name to which the route belongs
 * @param {boolean} routesData[].apiEndPointSchema.noMenu - Indicates if the route should be hidden from the menu
 *
 * @returns {React.Element} The rendered sidebar menu component.
 */
export const OrgAppLayoutMenubar = ({ setToggleMenu, activeOrgRoutes, authDetails, envData }) => {
  const activeMenuGroupOrg = sessionStorage.getItem('menuGroupActive')
    ? JSON.parse(sessionStorage.getItem('menuGroupActive'))
    : null
  const [activeGroupOrg, setActiveGroupOrg] = React.useState(activeMenuGroupOrg)

  const menusOrg = activeOrgRoutes.formData?.Pages?.filter(
    (f) => f.isPrivate === 1 || f.isPrivate === true,
  )
  let menuOrg = []
  activeOrgRoutes.formData?.Pages?.forEach((p) =>
    p.pageRoles.filter((f) => f.roleName === authDetails.orgRole && menuOrg.push(p)),
  )
  let userMenuOrg = []
  menuOrg.forEach((m) =>
    menusOrg.forEach((mn) => mn.pageName === m.pageName && userMenuOrg.push(mn)),
  )
  const parsedMenuOrg = []
  userMenuOrg.map((m) => {
    const parsed = JSON.parse(m.apiEndPointSchema)
    parsedMenuOrg.push({ ...m, apiEndPointSchema: parsed })
  })
  const userMenuGroupedOrg = _.groupBy(parsedMenuOrg, (g) => g.apiEndPointSchema.group)
  // activeOrgRoutes !== null &&
  //   activeOrgRoutes.formData?.Pages?.map((activeRoute) => {
  //     if (activeRoute.isPrivate === 1) {
  //       if (
  //         activeRoute.pageName !== 'MyKids' ||
  //         activeRoute.pageName !== 'MyProfile' ||
  //         activeRoute.pageName !== 'MyFamily' ||
  //         activeRoute.pageName !== 'MyProfile' ||
  //         activeRoute.pageName !== 'Users'
  //       ) {
  //         menusOrg.push(activeRoute)
  //       }
  //     }
  //   })

  // const parsedMenuOrg = []
  // menusOrg.map((m) => {
  //   const parsed = JSON.parse(m.apiEndPointSchema)
  //   parsedMenuOrg.push({ ...m, apiEndPointSchema: parsed })
  // })

  // const userMenuGroupedOrg = _.groupBy(parsedMenuOrg, (g) => g.apiEndPointSchema.group)

  const urlPath = window.location.pathname
  const urlLink = urlPath.split('/organization/')

  const activateMenuGroup = (group, link) => {
    sessionStorage.setItem('menuGroupActive', group)
    sessionStorage.setItem('menuGroupActiveLink', link)
    setActiveGroupOrg(group)
  }
  const deActivateMenuGroup = () => {
    sessionStorage.removeItem('menuGroupActive')
    sessionStorage.removeItem('menuGroupActiveLink')
  }
  return (
    <>
      {Object.keys(userMenuGroupedOrg)
        .sort((a, b) => a.localeCompare(b))
        .map((grp, grpInd) =>
          grp === 'undefined' ? (
            <React.Fragment key={grpInd}>
              {Object.keys(userMenuGroupedOrg)
                .sort((a, b) => a.localeCompare(b))
                .map((grp, grpInd) => (
                  <React.Fragment key={grpInd}>
                    {userMenuGroupedOrg[grp]
                      .sort((a, b) => a['pageTitle'].localeCompare(b['pageTitle']))
                      .map(
                        (menu, menuIndex) =>
                          menu.isVisible &&
                          envData.REACT_APP_APP_ISONLINE &&
                          grp === 'undefined' && (
                            <React.Fragment key={menuIndex}>
                              {!menu.apiEndPointSchema.noMenu && (
                                <AppLayoutMenuItems
                                  key={menuIndex}
                                  setToggleMenu={setToggleMenu}
                                  menuItem={menu}
                                  urlLink={urlLink[1]}
                                  isUndefined={true}
                                  deActivateMenuGroup={deActivateMenuGroup}
                                  linkPrefix="organization"
                                />
                              )}
                            </React.Fragment>
                          ),
                      )}
                  </React.Fragment>
                ))}
            </React.Fragment>
          ) : (
            <React.Fragment key={grpInd}>
              <li className="trtui-nav-item">
                <span
                  className={`trtui-nav-link trtui-menu-link trtui-cursor-pointer ${activeGroupOrg === grpInd ? 'trtui-active' : ''}`}
                  onClick={() =>
                    activateMenuGroup(activeGroupOrg === grpInd ? null : grpInd, urlLink[1])
                  }
                  style={{
                    fontSize: '.8375rem',
                    textTransform: 'uppercase',
                  }}
                >
                  {grp}{' '}
                  <i
                    className={`${activeGroupOrg === grpInd ? 'ri-arrow-down-s-line' : 'ri-arrow-right-s-line'}`}
                    style={{ position: 'absolute', right: '0px' }}
                  />
                </span>
                <div
                  className={`trtui-collapse trtui-menu-dropdown ${activeGroupOrg === grpInd ? 'trtui-show' : ''}`}
                  style={{
                    WebkitTransition: 'all 0.6s linear 0.4s',
                    msTransition: 'all 0.6s linear 0.4s',
                    transition: 'all 0.6s linear 0.4s',
                  }}
                >
                  {userMenuGroupedOrg[grp]
                    .sort((a, b) => a['pageTitle'].localeCompare(b['pageTitle']))
                    .map((menu, menuIndex) => (
                      <React.Fragment key={menuIndex}>
                        {envData.REACT_APP_APP_ISONLINE === '1' ? (
                          <>
                            {!menu.apiEndPointSchema.noMenu && menu.isVisible === true && (
                              <AppLayoutMenuItems
                                key={menuIndex}
                                setToggleMenu={setToggleMenu}
                                menuItem={menu}
                                urlLink={urlLink[1]}
                                grp={grp}
                                linkPrefix="organization"
                              />
                            )}
                          </>
                        ) : (
                          <>
                            {!menu.apiEndPointSchema.noMenu && (
                              <AppLayoutMenuItems
                                key={menuIndex}
                                setToggleMenu={setToggleMenu}
                                menuItem={menu}
                                urlLink={urlLink[1]}
                                grp={grp}
                                linkPrefix="organization"
                              />
                            )}
                          </>
                        )}
                      </React.Fragment>
                    ))}
                </div>
              </li>
            </React.Fragment>
          ),
        )}
    </>
  )
}

OrgAppLayoutMenubar.propTypes = {
  toggleMenu: PropTypes.bool.isRequired,
  setToggleMenu: PropTypes.func.isRequired,
  sideMenuRef: PropTypes.object.isRequired,
  activeOrgRoutes: PropTypes.object,
  authDetails: PropTypes.object,
  envData: PropTypes.object,
}
